<div id="{{touchScreen ? 'vehicle-anglesTouchScreen' : 'vehicle-angles'}}" (click)="toggleState()">
    <!-- New-->
    <div *ngIf="folders >= 13" class="circle new-circle" [ngClass]="{'zoomed3': stateFlag}"
        (mouseover)="circleHover(4)">
        <div class="angle top left dezoomed2" (click)="choiceAngle(13,$event)" [ngClass]="classesForAngle(13)"></div>
        <div class="angle top right dezoomed2" (click)="choiceAngle(14,$event)" [ngClass]="classesForAngle(14)"></div>
        <div class="angle bottom right dezoomed2" (click)="choiceAngle(15,$event)" [ngClass]="classesForAngle(15)">
        </div>
        <div class="angle bottom left dezoomed2" (click)="choiceAngle(16,$event)" [ngClass]="classesForAngle(16)"></div>
    </div>
    <!-- Outer-->
    <div class="circle outer-circle" [ngClass]="{'zoomed2': stateFlag}" (mouseover)="circleHover(2)">
        <div class="angle top left dezoomed2" (click)="choiceAngle(9,$event)" [ngClass]="classesForAngle(9)"></div>
        <div class="angle top right dezoomed2" (click)="choiceAngle(10,$event)" [ngClass]="classesForAngle(10)"></div>
        <div class="angle bottom right dezoomed2" (click)="choiceAngle(11,$event)" [ngClass]="classesForAngle(11)">
        </div>
        <div class="angle bottom left dezoomed2" (click)="choiceAngle(12,$event)" [ngClass]="classesForAngle(12)"></div>
    </div>
    <!-- Mid -->
    <div class="circle mid-circle" [ngClass]="{'zoomed': stateFlag}" (mouseover)="circleHover(1)">
        <div class="angle top left dezoomed" (click)="choiceAngle(5,$event)" [ngClass]="classesForAngle(5)"></div>
        <div class="angle top right dezoomed" (click)="choiceAngle(6,$event)" [ngClass]="classesForAngle(6)"></div>
        <div class="angle bottom right dezoomed" (click)="choiceAngle(7,$event)" [ngClass]="classesForAngle(7)"></div>
        <div class="angle bottom left dezoomed" (click)="choiceAngle(8,$event)" [ngClass]="classesForAngle(8)"></div>
    </div>
    <!-- Inner -->
    <div class="circle inner-circle" (mouseover)="circleHover(3)">
        <div class="angle top left" (click)="choiceAngle(1,$event)" [ngClass]="classesForAngle(1)"></div>
        <div class="angle top right" (click)="choiceAngle(2,$event)" [ngClass]="classesForAngle(2)"></div>
        <div class="angle bottom right" (click)="choiceAngle(3,$event)" [ngClass]="classesForAngle(3)"></div>
        <div class="angle bottom left" (click)="choiceAngle(4,$event)" [ngClass]="classesForAngle(4)"></div>
        <img src="../../../assets/icon/vehicle.png" height="70" alt="î">
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/vehicle-angles/vehicle-angles.component.html